export enum ResizingStatus {
    Maximized,
    VerticalMaximized,
    Normal,
    Hidden,
}
